/**
 * Minimal chrome for controller / regular kiosk roles.
 * Display kiosk has no navbar (handled by Navbar entrypoint).
 */
import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCog, faHouse, faRotateRight } from '@fortawesome/free-solid-svg-icons'
import { useNavigate } from 'react-router-dom'
import SettingsModal from './SettingsModal'
import { useKioskRole } from '../hooks/useKioskRole'
import {
  requestKioskDisplayRefresh,
  kioskSoftReload,
} from '../utils/kioskDisplaySync'

const KioskNavbar: React.FC = () => {
  const [settingsOpen, setSettingsOpen] = useState(false)
  const navigate = useNavigate()
  const kioskRole = useKioskRole()

  const handleHome = () => {
    navigate('/', { replace: true })
  }

  const handleRefresh = async () => {
    if (kioskRole === 'controller') {
      try {
        await requestKioskDisplayRefresh('controller')
        await new Promise((r) => setTimeout(r, 150))
      } catch {
        /* soft-fail — still refresh local */
      }
    }
    kioskSoftReload()
  }

  return (
    <>
      <SettingsModal open={settingsOpen} onClose={() => setSettingsOpen(false)} />
      <div className="navbar bg-base-100 shadow-lg border-b border-base-300 px-3 sm:px-4">
        <div className="navbar-start">
          <button
            type="button"
            className="btn btn-ghost btn-circle"
            aria-label="Home"
            onClick={handleHome}
          >
            <FontAwesomeIcon icon={faHouse} className="text-xl" />
          </button>
        </div>
        <div className="navbar-end flex items-center gap-0.5">
          <button
            type="button"
            className="btn btn-ghost btn-circle"
            aria-label="Refresh"
            onClick={() => void handleRefresh()}
          >
            <FontAwesomeIcon icon={faRotateRight} className="text-xl" />
          </button>
          <button
            type="button"
            className="btn btn-ghost btn-circle"
            aria-label="Settings"
            onClick={() => setSettingsOpen(true)}
          >
            <FontAwesomeIcon icon={faCog} className="text-xl" />
          </button>
        </div>
      </div>
    </>
  )
}

export default KioskNavbar
